import { getLocalStorage } from '@shared/core';

/**
 * Tracks whether a guest has dismissed the identification dialog for a given event.
 * Stored in localStorage so dismissal persists across page reloads and re-mounts
 * but is scoped per device and per event (dismissing for event A still shows the
 * dialog for event B).
 */

const keyFor = (eventId: string) => `joy:guestIdDialogDismissed:${eventId}`;

export const hasDismissedGuestIdentificationDialog = (eventId: string): boolean => {
  if (!eventId) return false;
  try {
    return getLocalStorage().getItem(keyFor(eventId)) === 'true';
  } catch {
    return false;
  }
};

export const markGuestIdentificationDialogDismissed = (eventId: string): void => {
  if (!eventId) return;
  try {
    getLocalStorage().setItem(keyFor(eventId), 'true');
  } catch {
    // Storage unavailable (private mode, quota exceeded, etc.) — silently ignore.
    // Worst case: the dialog shows again on next load, which is recoverable.
  }
};
